var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHrk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.2677C24 10.7998 23.736 9.39372 23.2536 8.09379L12 7.57202L0.746391 8.09374C0.264047 9.39372 0 10.7998 0 12.2677C0 13.7355 0.264047 15.1416 0.746391 16.4416L12 16.9633L23.2536 16.4416C23.736 15.1416 24 13.7355 24 12.2677Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 24.2653C17.1593 24.2653 21.5578 21.0088 23.2533 16.4392H0.746094C2.44161 21.0088 6.84013 24.2653 11.9997 24.2653Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.746094 8.09344H23.2534C21.5578 3.52383 17.1593 0.267334 11.9997 0.267334C6.84012 0.267334 2.44161 3.52383 0.746094 8.09344Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1299 8.61486H13.043L13.3908 6.00613L14.7821 4.96265L16.1734 6.00613V8.0931L15.1299 8.61486Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.86961 8.61486H10.9566L10.6087 6.00613L9.21742 4.96265L7.82617 6.00613V8.0931L8.86961 8.61486Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3901 8.61486H10.6074V6.00613L11.9988 4.96265L13.3901 6.00613V8.61486Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82617 8.09155V13.8306C7.82617 15.1972 8.48627 16.4125 9.50439 17.1743L10.2348 16.9916L11.1566 17.9188C11.4292 17.975 11.7112 18.0046 12.0001 18.0046C12.2875 18.0046 12.5681 17.9754 12.8392 17.9198L13.8914 17.0437L14.4957 17.1726C15.5134 16.4108 16.174 15.1968 16.174 13.8306V8.09155H7.82617Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49572 8.09155H7.82617V9.7611H9.49572V8.09155Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8336 8.09155H11.1641V9.7611H12.8336V8.09155Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1735 8.09155H14.5039V9.7611H16.1735V8.09155Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1656 9.75952H9.49609V11.4291H11.1656V9.75952Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5055 9.75952H12.8359V11.4291H14.5055V9.75952Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49572 11.4314H7.82617V13.1009H9.49572V11.4314Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1656 13.0994H9.49609V14.7689H11.1656V13.0994Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8336 11.4314H11.1641V13.1009H12.8336V11.4314Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1735 11.4314H14.5039V13.1009H16.1735V11.4314Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5055 13.0994H12.8359V14.7689H14.5055V13.0994Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8336 14.7712H11.1641V16.4408H12.8336V14.7712Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49542 14.7712H7.93359C8.07684 15.3919 8.35847 15.9598 8.74462 16.4408H9.49542V14.7712Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5039 16.4408H15.2547C15.6409 15.9598 15.9224 15.3918 16.0657 14.7712H14.5039V16.4408Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49609 16.4392V17.1677C9.98167 17.5331 10.5491 17.7951 11.1656 17.9208V16.4392H9.49609Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8359 16.4392V17.9208C13.4525 17.7952 14.0199 17.5331 14.5055 17.1677V16.4392H12.8359Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHrk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HRK.eb13ccacc7846b155e9edd82863ae827.svg";